import Dexie, { Table, EntityTable } from 'dexie'

import { Alias, AuditCampaign, Authority, ConditionReport, DataSynchronizerStats, EntityField, Expression, Item, Location, Manifestation, Record, Thesaurus, ThesaurusTerm, Translation, Work } from '@skinsoft/types'

export const CACHE_DOWN_DB_NAME = "cache-down"

export const dbCacheDown = new Dexie(CACHE_DOWN_DB_NAME) as Dexie & {
    alias: EntityTable<
        Alias,
        'id'
    >,
    auditCampaign: EntityTable<
        AuditCampaign,
        'id'
    >,
    auditRecord: EntityTable<
        Record,
        'id'
    >,
    authority: EntityTable<
        Authority,
        'id'
    >,
    conditionReport: EntityTable<
        ConditionReport,
        'id'
    >,
    expression: EntityTable<
        Expression,
        'id'
    >,
    entityField: EntityTable<
        EntityField,
        'id'
    >,
    item: EntityTable<
        Item,
        'id'
    >,
    location: EntityTable<
        Location,
        'id'
    >,
    manifestation: EntityTable<
        Manifestation,
        'id'
    >,
    syncDownStats: Table<
        DataSynchronizerStats,
        string
    >,
    thesaurus: EntityTable<
        Thesaurus,
        'id'
    >,
    thesaurusTerm: EntityTable<
        ThesaurusTerm,
        'id'
    >,
    translation: Table<
        Translation[],
        string
    >,
    work: EntityTable<
        Work,
        'id'
    >,
}


dbCacheDown.version(1).stores({
    alias: 'id',
    auditCampaign: 'id',
    auditRecord: 'id',
    authority: 'id',
    conditionReport: 'id',
    entityField: 'id',
    expression: 'id',
    item: 'id',
    location: 'id',
    manifestation: 'id',
    syncDownStats: '',
    thesaurus: 'id',
    thesaurusTerm: 'id,thesaurusTermSkin.thesaurus,thesaurusTermSkin.genericTerm,pathIds',
    translation: '',
    work: 'id',
})